module.exports = {
    accepted: 'Pole :attribute musi być zaakceptowane.',
    alpha: 'Pole :attribute może zawierać tylko litery.',
    alpha_dash: 'Pole :attribute moze zawierać tylko litery, myślnik i podrkeślenie.',
    alpha_num: 'Pole :attribute moze zawierac tylko znaki alfanumeryczne.',
    between: 'Pole :attribute musi mieć długość od :min do :max.',
    confirmed: 'Pole :attribute nie spełnia warunku potwierdzenia.',
    email: 'Pole :attribute ma niepoprawny format adresu email.',
    date: 'Pole :attribute musi mieć poprawny format daty.',
    def: 'Pole :attribute zawiera błędy.',
    digits: 'Pole :attribute może zawierać tylko cyfry ze zbioru :digits.',
    different: 'Pola :attribute i :different muszą się różnić.',
    'in': 'Pole :attribute musi należeć do zbioru :in.',
    integer: 'Pole :attribute musi być liczbą całkowitą.',
    min: {
        numeric: 'Pole :attribute musi być równe conajmniej :min.',
        string: 'Pole :attribute musi zawierać conajmniej :min znaków.'
    },
    max: {
        numeric: 'Pole :attribute nie moze być większe :max.',
        string: 'Pole :attribute nie moze być dłuższe niż :max znaków.'
    },
    not_in: 'Pole :attribute nie może należeć do zbioru :not_in.',
    numeric: 'Pole :attribute musi być liczbą.',
    required: 'Pole :attribute jest wymagane.',
    required_if: 'Pole :attribute jest wymagane jeśli pole :other jest równe :value.',
    same: 'Pola :attribute i :same muszą być takie same.',
    size: {
        numeric: 'Pole :attribute musi być równe :size.',
        string: 'Pole :attribute musi zawierać :size znaków.'
    },
    string: 'Pole :attribute musi być ciągiem znaków.',
    url: 'Pole :attribute musi być poprawnym adresem URL.',
    regex: 'Pole :attribute nie spełnia warunku.',
    attributes: {}
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/validatorjs/src/lang/pl.js
 ** module id = 659
 ** module chunks = 0
 **/